import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { Pagination } from '@lion-design/core';
import { I_NormGroup } from '@Redux/search/interfaces';
import { setGroupListInfo } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import ResultNoData from '@components/SearchPage/ResultNoData';
import Spinner from '@components/Common/Spinner';
import getResultConditions from '@utils/getResultConditions';
import CardsList from './CardsList';
import styles from '../styles.module.scss';

const Pc = () => {
    const search = useSelector((state: RootState) => state.search);
    // 這裡抓資料
    const { GroupListInfo, DepthInfo, FilterItems, SortListBy, TagFiltersShow, ChangeItem, Tags } =
        search;
    const curPage = location.pathname;
    const [isNowPage, setIsNowPage] = useState<number>(1);

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();

    const { data, isLoading } = GroupListInfo;
    const resultConditions = getResultConditions({
        FilterItems,
        DepthInfo,
        SortListBy,
        TagFiltersShow,
        search,
    });

    const urlParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        if (!isMobile) {
            const reqBody = {
                ...resultConditions,
                Page: 1,
                PageSize: 10,
            };
            dispatch(setGroupListInfo(reqBody));
            setIsNowPage(1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [curPage, dispatch, resultConditions.TripTypes, Tags]);

    useEffect(() => {
        if (ChangeItem) {
            if (!isMobile) {
                const reqBody = {
                    ...resultConditions,
                    Page: 1,
                    PageSize: 10,
                };
                dispatch(setGroupListInfo(reqBody));
                setIsNowPage(1);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DepthInfo, FilterItems, SortListBy, TagFiltersShow]);

    // 頁數改變時重新打API
    const getCurPageList = (page: number) => {
        const reqBody = {
            ...resultConditions,
            Page: page,
            PageSize: 10,
        };
        dispatch(setGroupListInfo(reqBody));
        setIsNowPage(page);
    };

    if (isLoading) return <Spinner />;
    return data.NormGroupList.length > 0 ? (
        <>
            {data?.NormGroupList.map((item: I_NormGroup, i: number) => (
                <CardsList key={i} groupData={item} />
            ))}
            <Pagination
                className={styles.pageBar}
                total={data?.TotalCount}
                pageSize={10}
                current={isNowPage}
                onChange={(page) => {
                    getCurPageList(page);
                    // 換頁後跳至最放上
                    window.scrollTo(0, 0);
                }}
            />
        </>
    ) : (
        <ResultNoData />
    );
};

export default Pc;
